import { Card } from '@mui/material';
import { getEnvVar } from '../../utils/env';

export default function EnvironmentInformation() {
  let stage = getEnvVar('REACT_APP_ENV') || getEnvVar('VITE_ENV');
  if (!stage) {
    stage = 'Development';
  }
  if (stage !== 'Demo' && stage !== 'Production') {
    return (
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '16px',
          paddingLeft: '30px',
          fontWeight: 'bold',
          fontSize: '1.5rem',
          bgcolor: 'transparent',
          boxShadow: 'none',
        }}
      >
        <div style={{ color: 'red' }}>{stage} Environment</div>
      </Card>
    );
  }

  return <div />;
}
